<template>
    <Card>
        <div class="font-weight-bold">
            RETRIEVED DATA
        </div>
        <div class="bg-light-light rounded p-5">
            <pre>{{ data }}</pre>
        </div>

        <div class="mt-3">
            <div class="font-weight-bold">
                SUBMIT CUSTOMER NUMBER
            </div>
            <FormGroupNew label="Garantiert Geliefert Customer-ID" required>
                <input type="text" class="form-control" placeholder="Customer ID" v-model="form.customer_id">
            </FormGroupNew>
            <button class="btn btn-success"
                    :disabled="!form.isDirty"
                    @click="submit"
            >
                <i class="fas fa-send"/>
                Submit customer ID
            </button>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, Card},

    props: {
        url: String,
        data: Object
    },

    data() {
        return {
            form: this.$inertia.form({
                customer_id: null,
                update_customer: this.data.update_customer
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('GG.simulate.register'))
        }
    }
}
</script>
